import kebabCase from 'lodash/kebabCase';
import { Duration } from '../animations/component-lib.esm.js';
const PROFILE_PREFIX = 'p';
function getCSSVariableName(prefix, name) {
  return `--${prefix}-${kebabCase(name)}`;
}

/**
 * Take a group of theme settings and turn them into CSS variables.
 * @param {String} prefix
 * @param {Object} settings
 * @param {String} unit
 * @returns Key/value pairs of CSS variables
 */
function convertToCSSVariable(prefix, settings) {
  let unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const styles = Object.keys(settings).reduce((accum, key) => {
    accum[getCSSVariableName(prefix, key)] = `${settings[key]}${unit}`;
    return accum;
  }, {});
  return styles;
}

/**
 * Take key/value pairs of CSS variables and turn them into a CSS string.
 * @param {Object} styles
 * @returns CSS variables as a string
 */
function cssVariablesToString(styles) {
  return Object.keys(styles).map(key => `${key}: ${styles[key]};`).join('\n');
}

// Get only the profile CSS variables
function getProfileCSSVariables(profile) {
  return convertToCSSVariable(PROFILE_PREFIX, profile);
}
function getThemeCSSVariables(theme) {
  const colors = convertToCSSVariable('g-color', theme.colors);
  const fonts = convertToCSSVariable('g-font', theme.font);
  const button = convertToCSSVariable('g-button', theme.button);
  const zIndex = convertToCSSVariable('g-zindex', theme.zIndex);
  const profile = getProfileCSSVariables(theme.profile);
  const borderRadius = convertToCSSVariable('g-border-radius', theme.borderRadius, 'rem');
  const duration = convertToCSSVariable('g-duration', Duration, 'ms');
  return {
    ...colors,
    ...fonts,
    ...button,
    ...zIndex,
    ...profile,
    ...borderRadius,
    ...duration
  };
}
export { PROFILE_PREFIX, convertToCSSVariable, cssVariablesToString, getCSSVariableName, getProfileCSSVariables, getThemeCSSVariables };